import React, { useState } from "react";
import TopNav from "../Navbars/TopNav";
import Sidebar from "../Navbars/sidebar";
import AcceptedTable from "./table/accepttable";
import { Link } from "react-router-dom";
import ApplicationSummary from "../information_cards/ApplicationSummary";

function FinalSiwesApplicationsPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <>
      {" "}
      <TopNav />
      <div className="flex h-screen overflow-hidden">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <div className="flex ">
            <span className="relative top-[7.2rem] mt-4 text-gray-500 font-semibold left-10 mb-6">
              Approved SIWES Applications To Send Acceptance Mail
            </span>
          </div>
          <main className=" mt-14">
            <div className=" flex space-x-4 mt-12 m-auto">
              <AcceptedTable internship_type={"siwes"} />
            </div>
            <div className="px-2 sm:px-2 lg:px-2 py-2 w-full max-w-9xl mx-auto">
              {/* <WelcomeBanner /> */}
              {/* <div className=" bg-white border-1 shadow h-full p-1 border-2 rounded-lg"> */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2 mt-4 mb-2">
                {/* <FilterButton /> */}
                {/* <Datepicker />
                  <button className="btn bg-green-500 hover:bg-green-600 text-white">
                    <svg
                      className="w-4 h-4 fill-current opacity-50 shrink-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                    </svg>
                  </button> */}
                {/* </div> */}
                {/* <ApplicationSummary /> */}
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default FinalSiwesApplicationsPage;
